'use strict';

var FlightSeasonFilterFactory = function FlightSeasonFilterFactory(DataFilter, SeasonLabelFormattingService) {
  function FlightSeasonFilter() {
    this.sourceType = ['cabin', 'cabin-da', 'cabin-post-departure', 'class'];
    this.filterType = 'season';
  }
  FlightSeasonFilter.constructor = FlightSeasonFilter;
  FlightSeasonFilter.prototype = Object.create(DataFilter.prototype);
  FlightSeasonFilter.prototype.groupBy = ['seasonOverride', 'season'];
  FlightSeasonFilter.prototype.filter = function (data, range) {
    var convertedRange = [];
    for (var i = 0, len = range.length; i < len; i++) {
      var element = range[i];
      var newElement = SeasonLabelFormattingService.formatSeasonFilter(element);
      convertedRange.push(newElement ? newElement.replace(/\s/g, '').toLowerCase() : newElement);
    }
    return DataFilter.prototype.filter(data, convertedRange, this.groupBy);
  };
  return FlightSeasonFilter;
};
FlightSeasonFilterFactory.$inject = ['DataFilterFactory', 'SeasonLabelFormattingService'];
module.exports = FlightSeasonFilterFactory;